import { Component, Injector, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import {GoogleMapsComponent} from '../../../google-maps/google-maps.component';
import {AutoSchedulerService} from '../../../../auto-scheduler/auto-scheduler.service';
import {DriversService} from '../../../../drivers/drivers.service';
import {T2LoadingService} from '../../../../../trip2-theme/components/t2-loading/t2-loading.service';
import {constant} from '../../../../../app.constants';
import {SignalRService} from '../../../../../core/services/signal-r.service';
import {TripModelR} from '../../../../trip-reservations/trip.model';
import {IDriverLocation} from '../../../../../core/interfaces/driver.interface';
import {IDriverScheduleTrip, ITripRouteDetails} from '../../../../../core/interfaces/schedule-trip.interface';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {TripStatusEnum} from '../../../../../core/enums/trips-status.enum';
import { CompaniesEnum, CompaniesList } from 'app/core/enums/companies.enum';
import { ParentModule } from 'app/pages/A2-utils/ParentClass/parent-module';
import { Subscription } from 'rxjs/Subscription';

const moment = require('moment');
@Component({
  selector: 'app-map-view',
  templateUrl: './map-view.component.html',
  styleUrls: ['./map-view.component.scss']
})
export class MapViewComponent extends ParentModule implements OnInit, OnChanges, OnDestroy {

  @Input() pickupLocation?: any;
  @Input() dropoffLocation?: any;
  @Input() model?: TripModelR;

  @ViewChild(GoogleMapsComponent) map: GoogleMapsComponent;
  public mapReady = false;
  public routeDrawing: RouteDrawing;
  public routeDrawingPickUpToDropOff: RouteDrawingPickUpToDropOff;
  private currentDriverDetails: CurrentDriverDetails;
  tripRouteDetails = new BehaviorSubject<ITripRouteDetails>(null);
  tripRouteDetails$ = this.tripRouteDetails.asObservable();
  private routeToFirstDestination: {lat: any, lng: any, order?: number}[] = [];
  public isShowPolylineToPickUp = true;
  public isShowPolylinePickUpToDropOff = false;
  public statusEnabledShowControl = [
    TripStatusEnum.Accepted,
    TripStatusEnum.OnMyWay,
    TripStatusEnum.Arrived,
    TripStatusEnum.PickUp,
  ];
  public showDriversPhone = false;
  private subscriptions: Array<Subscription> = [];
  public isClientUser: boolean = JSON.parse(localStorage.getItem('currentUser')).isClient;

  constructor(
    protected autoSchedulerService: AutoSchedulerService,
    protected driverService: DriversService,
    protected loading: T2LoadingService,
    private signalR: SignalRService,
    protected inject: Injector
  ) {
    super('app-edit-reservation-form', inject);
    this.signalR.start().then();
    this.observingChanges();
    this.loading.show('Loading Route Information...');
  }

  ngOnInit() {
    this.loading.hiden();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['model']) {
      this.getTripRouteDetails();
    }
  }

  getTripRouteDetails() {
    this.loading.show('Loading Route Information...');
    this.driverService.getTripRouteDetails(this.model.tripid)
      .toPromise()
      .then(resp => {
        this.generateTimeLyft(resp);
        this.tripRouteDetails.next(resp);
        setTimeout(() => this.loading.hiden(), 2000);
      }).catch(() => setTimeout(() => this.loading.hiden(), 2000));
  }

  observingChanges() {
    this.subscriptions.push(
      this.tripRouteDetails$.subscribe((tripRouteDetails) => {
        if (tripRouteDetails && this.mapReady) {
          this.mediaDrawingRoute(tripRouteDetails);
        }
      }),
      this.$actions.subscribe(data => {
        this.showDriversPhone = this.isAllowedAction('ShowDriverPhoneClientUser');
      })
    );
  }

  generateTimeLyft(tripRouteDetails:  ITripRouteDetails) {
    let etaPickupTime = [];
    let etaDropOffTime = [];

    if (tripRouteDetails.etapickups) {
      const etaPickupHms = moment(0, 'HH:mm')
        .add(tripRouteDetails.etapickups, 'seconds')
        .format('H:m');
      etaPickupTime = etaPickupHms.split(':');
    }

    if (tripRouteDetails.etadropoffs) {
      const etaDropOffHms = moment(0, 'HH:mm')
        .add(tripRouteDetails.etadropoffs, 'seconds')
        .format('H:m');
      etaDropOffTime = etaDropOffHms.split(':');
    }

    tripRouteDetails.etapickuptime = etaPickupTime ? this.formatTime(etaPickupTime) : undefined;
    tripRouteDetails.etadropOfftime = etaDropOffTime ? this.formatTime(etaDropOffTime) : undefined;
  }

  formatTime(time: number[]) {
    return ((time[0] > 0 ? `${time[0]} h` : '') + (time[1] > 0 ? ` ${time[1]} min` : ''));
  }

  initializedDrawingRoute() {
    if (this.tripRouteDetails.value) {
      this.mediaDrawingRoute(this.tripRouteDetails.value);
    }
  }

  mediaDrawingRoute(tripRouteDetails: ITripRouteDetails) {
    if (!this.routeDrawingPickUpToDropOff) {
      this.routeDrawingPickUpToDropOff = new RouteDrawingPickUpToDropOff(
        this.autoSchedulerService,
        this.map,
        this.model,
        this.isShowPolylinePickUpToDropOff
      );
    }

    if (this.currentDriverDetails) {
      this.currentDriverDetails.trip = this.model;
      this.currentDriverDetails.tripRouteDetails = tripRouteDetails;
      this.currentDriverDetails.routeToFirstDestination = this.routeToFirstDestination;
      this.currentDriverDetails.routeDrawing = this.routeDrawing ? this.routeDrawing : undefined;
      this.currentDriverDetails.startCurrentDriverDetails();
    } else {
      this.currentDriverDetails = new CurrentDriverDetails(
        this.autoSchedulerService,
        this.signalR,
        this.map,
        this.model,
        tripRouteDetails,
        this.routeToFirstDestination,
        this.routeDrawing
      );
    }

    switch (this.model.tripstatusid) {
      case TripStatusEnum.Accepted:
      case TripStatusEnum.OnMyWay:
      case TripStatusEnum.Arrived:
      case TripStatusEnum.PickUp:
        if (this.routeDrawing) {
          // TODO ACTUALIZAR RUTA PENSAR EN UN METODO PARA LLAMAR AL SCHEDULEROUTE UY PINTAR DE NUEVO LA RUTA
          this.routeDrawing.trip = this.model;
          this.routeDrawing.routeToFirstDestination = this.routeToFirstDestination;
          this.routeDrawing.routeDrawingPickUpToDropOff = this.routeDrawingPickUpToDropOff;
          this.routeDrawing.tripRouteDetails = tripRouteDetails;
        } else {
          this.routeDrawing = new RouteDrawing(
            this.loading,
            this.autoSchedulerService,
            this.map,
            this.model,
            this.routeToFirstDestination,
            this.routeDrawingPickUpToDropOff,
            tripRouteDetails
          );
        }
        this.currentDriverDetails.routeDrawing = this.routeDrawing;
        break;
    }
  }

  getTripHistoryDetail() {
    this.driverService.getTripHistoryDetail(this.model.tripid).subscribe(
      data => {
        const accepted = data.accepted;
        const pickup = data.pickup;
        const complete = data.complete;
        const markerAc =
          this.map.addMarker({lat: accepted.latitude, lng: accepted.longitude},
            this.map.customIcon('A', 'ffa20a'), 'Accepted');
        const markerPU =
          this.map.addMarker({lat: pickup.latitude, lng: pickup.longitude},
            this.map.customIcon('DP', '0072e9'), 'Driver Pickup');
        const markerDO =
          this.map.addMarker({lat: complete.latitude, lng: complete.longitude},
            this.map.customIcon('DC', 'ff9c9c'), 'Driver Completed');

        this.map.addMarkerCustomInfoWindowMultiLines(markerAc, [accepted.time]);
        this.map.addMarkerCustomInfoWindowMultiLines(markerPU, [pickup.time]);
        this.map.addMarkerCustomInfoWindowMultiLines(markerDO, [complete.time]);
      }
    );
  }

  get providerDescription(): string {
    const provider = CompaniesList.find(
      (provider) => provider.id === this.model.companyid);
    return provider.description;
  }

  getProviderClass(): string {
    let styleClass: string;
    switch (this.model.companyid) {
      case CompaniesEnum.Lyft:
        styleClass = 'icon-lyft-route';
        break;
      case CompaniesEnum.Uber:
        styleClass = 'icon-uber-route';
        break;
    }
    return styleClass;
  }

  get showDriverPhone() {
    return !this.isClientUser || (this.isClientUser && this.showDriversPhone);
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.forEach((subscription: Subscription) => {
        subscription.unsubscribe();
      });
    }
    this.signalR.unsubscribeTo('updateLocation');
    this.signalR.unsubscribeTo('tripNotification');
    this.signalR.stop();
  }
}

class RouteDrawing {
  public scheduleTrips: IDriverScheduleTrip[] = [];
  public destinationScheduleTrip: any;
  protected markers: any[] = [];
  private iconCircleBlue = '../../../../../assets/images/marker/blue-circle.svg';
  public destinationMarker;
  public polylineToPickUp;
  public timeETA: { stringRouteDuration: string; approximateTime: string };
  public routeFull: {lat: any, lng: any, order?: number}[] = [];
  public timeNowServer: string;
  constructor(
    private loading: T2LoadingService,
    private autoSchedulerService: AutoSchedulerService,
    private map: GoogleMapsComponent,
    public trip: TripModelR,
    public routeToFirstDestination: {lat: any, lng: any, order?: number}[],
    public routeDrawingPickUpToDropOff: RouteDrawingPickUpToDropOff,
    public tripRouteDetails: ITripRouteDetails
  ) {
    this.destinationMarker = this.trip.tripstatusid === TripStatusEnum.PickUp ?
      this.routeDrawingPickUpToDropOff.dropOffMarker :
      this.routeDrawingPickUpToDropOff.pickUpMarker;

    this.getTimeNow();
    this.getRouteToPickUpScheduleTrip();
  }

  getRouteToPickUpScheduleTrip() {
    this.loading.show('Loading Route and ETA...');
    if (this.tripRouteDetails.ondemandtrip || this.tripRouteDetails.lyfttrip || !this.tripRouteDetails.driverid) {
      this.assemblingInfoForRoute();
    } else {
      this.autoSchedulerService.getRouteToPickUp(this.trip.tripid, this.trip.driverid)
        .toPromise()
        .then((resp) => {
          if (resp) {
            this.scheduleTrips = resp;
            this.destinationScheduleTrip = this.scheduleTrips.find(f => f.tripid === this.trip.tripid);
            this.scheduleTrips.map((scheduleTrip, i) => {
              const latAndLng = {lat: scheduleTrip.triplocation.latitude, lng: scheduleTrip.triplocation.longitude, order: i};

              switch (scheduleTrip.locationtype) {
                case 'Start':
                  this.routeFull.unshift({
                    lat: this.routeToFirstDestination[0].lat,
                    lng: this.routeToFirstDestination[0].lng,
                    order: 0
                  });
                  break;
                case 'PU':
                case 'DO':
                  if (scheduleTrip.tripid !== this.trip.tripid) {
                    const marker = this.map.addMarkerLabel(
                      this.map.latLng(latAndLng.lat, latAndLng.lng),
                      this.iconCircleBlue,
                      (i).toString()
                    );
                    this.markers.push(marker);
                  }
                  if (i <= this.scheduleTrips.findIndex(f => f.tripid === this.trip.tripid)) {
                    this.routeToFirstDestination.push(latAndLng);
                  }
                  this.routeFull.push(latAndLng);
                  break;
              }
            });
            this.drawingPolylineToPickUp();
            this.updatedTimeETA(this.routeToFirstDestination);
            this.loading.hiden();
          } else {
           this.assemblingInfoForRoute();
          }
        })
        .catch(() => this.assemblingInfoForRoute());
    }
  }

  assemblingInfoForRoute() {
    if (this.routeToFirstDestination.length > 0) {
      this.destinationScheduleTrip = {
        locationtype: this.trip.tripstatusid === TripStatusEnum.PickUp ? 'DO' : 'PU',
        // TODO REVISAR PUT
        put: this.trip.tripstatusid === TripStatusEnum.PickUp ?
          this.trip.appointment :
          this.trip.pickup,
        triplocation: this.trip.tripstatusid === TripStatusEnum.PickUp ?
          this.trip.triplocationdropoff :
          this.trip.triplocationpickup,
      };
      this.routeFull.unshift({
        lat: this.routeToFirstDestination[0].lat,
        lng: this.routeToFirstDestination[0].lng,
        order: 0
      });
      if (this.trip.tripstatusid !== TripStatusEnum.PickUp) {
        this.routeFull.push(this.routeDrawingPickUpToDropOff.pickUpLatLng);
      }
      this.routeFull.push(this.routeDrawingPickUpToDropOff.dropOffLatLng);
      this.routeToFirstDestination.push({
        lat: this.destinationMarker.getPosition().lat(),
        lng: this.destinationMarker.getPosition().lng(),
        order: 0
      });
      this.drawingPolylineToPickUp();
      this.updatedTimeETA(this.routeToFirstDestination);
    }
    this.loading.hiden();
  }

  drawingPolylineToPickUp() {
    this.autoSchedulerService.osrmFullPath(this.routeFull)
      .toPromise()
      .then((osrmResp) => {
        const decodePolyline = this.map.decodePolyline(osrmResp.routes[0].geometry);
        this.polylineToPickUp = this.map.addPolylineDots(decodePolyline, 'rgba(0,0,0,0.7)');
      });
  }

  showPolylineToPickUp(value: boolean) {
    if (value) {
      this.drawingPolylineToPickUp();
    } else {
      this.map.removePolyline(this.polylineToPickUp);
    }
  }

  updatedTimeETA(routeToFirstDestination: {lat: any, lng: any, order?: number}[]) {
    this.autoSchedulerService.osrmFullPath(routeToFirstDestination)
      .toPromise()
      .then((osrmResp) => {
        const reducer = (accumulator, currentValue) => accumulator + currentValue;
        const capacityTypeDelay = this.scheduleTrips
          .filter((f, i) =>
            f.triplocation.capacitytypedelay &&
            f.tripid !== this.trip.tripid &&
            i <= this.scheduleTrips.findIndex(fi => fi.tripid === this.trip.tripid)
          ).map(f => f.triplocation.capacitytypedelay);
        let sumCapacityTypeDelay = 0;
        if (capacityTypeDelay.length) {
          sumCapacityTypeDelay = capacityTypeDelay.reduce(reducer);
        }

        this.timeETA = this.convertTime(osrmResp.routes[0].duration, sumCapacityTypeDelay);

        this.map.addCustomInfoWindow(this.destinationMarker, [
          'Location: ' + this.destinationScheduleTrip.triplocation.streetaddress,
          this.destinationScheduleTrip.locationtype + 'T: ' + moment(this.destinationScheduleTrip.put, 'hh:mm:ss').format('hh:mm A'),
          this.destinationScheduleTrip.locationtype + ' ETA: ' + this.timeETA.approximateTime,
          'Route Duration: ' + this.timeETA.stringRouteDuration,
          'Order: ' + (this.scheduleTrips.findIndex(f => f.tripid === this.trip.tripid) > 0 ?
              this.scheduleTrips.findIndex(f => f.tripid === this.trip.tripid) : 1
          ),
        ]);
      });
  }

  convertTime(duration: number, sumCapacityTypeDelay?: number): { stringRouteDuration: string; approximateTime: string } {
    this.getTimeNow();

    const approximateTime = moment(this.timeNowServer)
      .add(duration, 'seconds')
      .add(sumCapacityTypeDelay, 'minutes')
      .add((sumCapacityTypeDelay > 0 ? 5 : 0), 'minutes')
      .format('hh:mm A');

    const hms = moment(0, 'HH:mm')
      .add(duration, 'seconds')
      .add(sumCapacityTypeDelay, 'minutes')
      .add((sumCapacityTypeDelay > 0 ? 5 : 0), 'minutes')
      .format('H:m');
    const time = hms.split(':');
    const stringRouteDuration = ((time[0] > 0 ? `${time[0]} h` : '') + (time[1] > 0 ? ` ${time[1]} min` : ''));

    return {stringRouteDuration, approximateTime};
  }

  getTimeNow() {
    this.autoSchedulerService.getTimeNow()
      .toPromise()
      .then(resp => {
        if (resp) {
          this.timeNowServer = resp;
        }
      });
  }

  openInfoWindowMarker() {
    this.map.openInfoWindowMarker(this.destinationMarker.getPosition().lat(), this.destinationMarker.getPosition().lng());
  }
}

class CurrentDriverDetails {
  private iconCarGreen = 'assets/images/marker/marker-car-green.svg';
  private iconCar = 'assets/images/marker/marker-car.svg';
  private pin = 'assets/images/marker/pin.svg';
  private driverStartingLatAndLng: { lng: number; lat: number };
  private driverStartingPositionMarker;
  private driverRealTimePositionMarker;
  private driverProbablePolyline;
  public tripStatusValidShowIconCar = [
    {
      tripStatusId: TripStatusEnum.Open,
      showIconCar: false
    },
    {
      tripStatusId: TripStatusEnum.Active,
      showIconCar: false
    },
    {
      tripStatusId: TripStatusEnum.Hold,
      showIconCar: false
    },
    {
      tripStatusId: TripStatusEnum.Scheduled,
      showIconCar: false
    },
    {
      tripStatusId: TripStatusEnum.Accepted,
      showIconCar: true
    },
    {
      tripStatusId: TripStatusEnum.OnMyWay,
      showIconCar: true
    },
    {
      tripStatusId: TripStatusEnum.Arrived,
      showIconCar: true
    },
    {
      tripStatusId: TripStatusEnum.PickUp,
      showIconCar: true
    },
    {
      tripStatusId: TripStatusEnum.DropOff,
      showIconCar: false
    },
    {
      tripStatusId: TripStatusEnum.NoShow,
      showIconCar: false
    },
    {
      tripStatusId: TripStatusEnum.Cancelled,
      showIconCar: false
    },
  ];
  private isSignalRegistered: boolean;
  private isSignalRSubscribeTo;
  constructor(
    private autoSchedulerService: AutoSchedulerService,
    private signalR: SignalRService,
    private map: GoogleMapsComponent,
    public trip: TripModelR,
    public tripRouteDetails: ITripRouteDetails,
    public routeToFirstDestination: {lat: any, lng: any, order?: number}[],
    public routeDrawing: RouteDrawing
  ) {
    this.startCurrentDriverDetails();
  }

  startCurrentDriverDetails() {
    const pickUp = {lat: this.trip.triplocationpickup.latitude, lng: this.trip.triplocationpickup.longitude };
    const dropOff = {lat: this.trip.triplocationdropoff.latitude, lng: this.trip.triplocationdropoff.longitude };
    const showIconCar = this.tripStatusValidShowIconCar.find(f => f.tripStatusId === this.trip.tripstatusid).showIconCar
      && !!this.tripRouteDetails.latitude
      && !!this.tripRouteDetails.longitude
      && !!this.tripRouteDetails.drivername;

    if (showIconCar) {
      this.driverStartingLatAndLng = {lat: this.tripRouteDetails.latitude, lng: this.tripRouteDetails.longitude};
      this.driverMarkerDrawing();

      if (this.routeDrawing) {
        this.routeToFirstDestination[0] = this.driverStartingLatAndLng;
        if (this.routeToFirstDestination.length > 2) {
          this.routeDrawing.updatedTimeETA(this.routeToFirstDestination);
        }
      } else {
        this.routeToFirstDestination.unshift({
          lat: this.driverStartingLatAndLng.lat,
          lng: this.driverStartingLatAndLng.lng,
          order: 0
        });
      }

      switch (this.trip.tripstatusid) {
        case TripStatusEnum.Accepted:
        case TripStatusEnum.OnMyWay:
        case TripStatusEnum.Arrived:
        case TripStatusEnum.PickUp:
          if (this.tripRouteDetails.driverid) {
            this.startSignalR(this.tripRouteDetails.driverid);
          }
          break;
        default:
          if (this.tripRouteDetails.driverid) {
            this.signalrDeleteHubConnection(this.tripRouteDetails.driverid, true);
          }
      }
    } else {
      if (this.driverProbablePolyline) {
        this.map.removePolyline(this.driverProbablePolyline);
        this.driverProbablePolyline = undefined;
      }
      if (this.driverRealTimePositionMarker) {
        this.map.removeMarker(this.driverRealTimePositionMarker);
        this.driverRealTimePositionMarker = undefined;
      }
      if (this.driverStartingPositionMarker) {
        this.map.removeMarker(this.driverStartingPositionMarker);
        this.driverStartingPositionMarker = undefined;
      }
    }
    this.map.centerOverSomeMakers(showIconCar ? [this.driverStartingLatAndLng, pickUp, dropOff] : [pickUp, dropOff]);
  }

  driverMarkerDrawing() {
    if (this.driverStartingPositionMarker) {
      const markerLatLng = this.driverStartingPositionMarker.getPosition();
      if ((markerLatLng.lat() !== this.driverStartingLatAndLng.lat) && (markerLatLng.lng() !== this.driverStartingLatAndLng.lng)) {
        this.map.changeMarkerIcon(this.driverStartingPositionMarker, this.pin);
        if (this.driverRealTimePositionMarker) {
          this.map.removePolyline(this.driverProbablePolyline);
          this.driverProbablePolyline = undefined;
          this.map.changeMarkerIcon(this.driverRealTimePositionMarker, this.iconCar);
          this.map.moveMarker(this.driverRealTimePositionMarker, this.driverStartingLatAndLng);
        } else {
          this.driverRealTimePositionMarker = this.map.addMarker(this.driverStartingLatAndLng, this.iconCar);
        }
      }
    } else {
      this.driverStartingPositionMarker = this.map.addMarker(this.driverStartingLatAndLng, this.iconCar);
    }
  }

  startSignalR(driverId: number) {
    this.signalrHubConnection(driverId);
    if (!this.isSignalRSubscribeTo) {
      this.isSignalRSubscribeTo = true;
      this.signalR.subscribeTo('updateLocation', (value: IDriverLocation) => {
        const currentDriverLocation = { lat: value.Latitude,  lng: value.Longitude };
        this.map.changeMarkerIcon(this.driverStartingPositionMarker, this.pin);
        if (this.driverRealTimePositionMarker) {
          this.map.changeMarkerIcon(this.driverRealTimePositionMarker, this.iconCarGreen);
          this.map.moveMarker(this.driverRealTimePositionMarker, currentDriverLocation);
        } else {
          this.driverRealTimePositionMarker = this.map.addMarker(currentDriverLocation, this.iconCarGreen);
        }

        if (this.routeToFirstDestination) {
          const destination = this.routeToFirstDestination.length >= 2 ? this.routeToFirstDestination[1] : undefined;
          if (destination) {
            this.autoSchedulerService.osrmFullPath([currentDriverLocation, destination])
              .toPromise()
              .then((osrmResp) => {
                if (this.routeDrawing) {
                  this.routeToFirstDestination[0] = currentDriverLocation;
                  this.routeDrawing.updatedTimeETA(this.routeToFirstDestination);
                }
                const decodePolyline = this.map.decodePolyline(osrmResp.routes[0].geometry);
                if (this.driverProbablePolyline) {
                  this.driverProbablePolyline = this.map.updatedPolyline(this.driverProbablePolyline, decodePolyline, 'rgba(255,0,0,0.7)');
                } else {
                  this.driverProbablePolyline = this.map.addPolyline(decodePolyline, 'rgba(255,0,0,0.7)');
                }
              });
          }
        }
      });
    }
  }

  signalrHubConnection(driverId: number) {
    if (this.isSignalRegistered) {
      this.signalrDeleteHubConnection(driverId);
    } else {
     this.signalrRegisterHubConnection(driverId);
    }
  }

  signalrRegisterHubConnection(driverId: number) {
    this.signalR.registerHubConnection(constant.URL_HUB_DRIVER_LOCATION, driverId)
      .toPromise()
      .then(() => this.isSignalRegistered = true)
      .catch(() => this.isSignalRegistered = false);
  }

  signalrDeleteHubConnection(driverId: number, end?: boolean) {
    this.signalR.deleteHubConnection(constant.URL_HUB_DRIVER_LOCATION, driverId)
      .toPromise()
      .then(() => {
        this.isSignalRegistered = false;
        if (!end) {
          this.signalrRegisterHubConnection(driverId);
        }
      })
      .catch(() => this.isSignalRegistered = false);
  }
}

class RouteDrawingPickUpToDropOff {
  private iconCircleGreen = '../../../../../assets/images/marker/green-circle.svg';
  private iconCircleRed = '../../../../../assets/images/marker/red-circle.svg';
  public pickUpLatLng: { lng: number; lat: number };
  public dropOffLatLng: { lng: number; lat: number };
  public pickUpMarker;
  public dropOffMarker;
  public polylinePickUpToDropOff;
  constructor(
    protected autoSchedulerService: AutoSchedulerService,
    protected map: GoogleMapsComponent,
    protected trip: TripModelR,
    protected isShowPolylinePickUpToDropOff: boolean,
  ) {
    this.pickUpLatLng = {lat: this.trip.triplocationpickup.latitude, lng: this.trip.triplocationpickup.longitude };
    this.dropOffLatLng = {lat: this.trip.triplocationdropoff.latitude, lng: this.trip.triplocationdropoff.longitude };

    this.pickUpMarker = this.map.addMarkerLabel(
      this.map.latLng(this.pickUpLatLng.lat, this.pickUpLatLng.lng),
      this.iconCircleGreen,
      'PU',
      10
    );
    this.dropOffMarker = this.map.addMarkerLabel(
      this.map.latLng(this.dropOffLatLng.lat, this.dropOffLatLng.lng),
      this.iconCircleRed,
      'DO',
      10
    );

    if (
      this.isShowPolylinePickUpToDropOff ||
      this.trip.tripstatusid === TripStatusEnum.Open ||
      this.trip.tripstatusid === TripStatusEnum.Scheduled ||
      this.trip.tripstatusid === TripStatusEnum.Active ||
      this.trip.tripstatusid === TripStatusEnum.Hold ||
      this.trip.tripstatusid === TripStatusEnum.NoShow ||
      this.trip.tripstatusid === TripStatusEnum.Cancelled ||
      this.trip.tripstatusid === TripStatusEnum.DropOff
    ) {
      this.drawingPolylinePickUpToDropOff();
    }
  }

  drawingPolylinePickUpToDropOff() {
    this.autoSchedulerService.osrmFullPath([this.pickUpLatLng, this.dropOffLatLng])
      .toPromise()
      .then((osrmResp) => {
        const decodePolyline = this.map.decodePolyline(osrmResp.routes[0].geometry);
        this.polylinePickUpToDropOff = this.map.addPolyline(decodePolyline, 'rgb(0,0,255,0.7)', 2);
      });
  }

  showPolylinePickUpToDropOff(value: boolean) {
    if (value) {
      this.drawingPolylinePickUpToDropOff();
    } else {
      this.map.removePolyline(this.polylinePickUpToDropOff);
    }
  }

  centerMapOnPickUpToDropOff() {
    this.map.centerOverSomeMakers([this.pickUpLatLng, this.dropOffLatLng]);
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/map-route/components/map-view/map-view.component.ts